// Type definitions for Electron API exposed via preload
export interface ElectronAPI {
  getVersion: () => Promise<string>;
  onPTTHotkeyChanged: (hotkey: string) => void;
  getPTTHotkey: () => Promise<string>;
  getPTTState: () => Promise<boolean>;
  onPTTStateChanged: (callback: (pressed: boolean) => void) => void;
  removePTTStateListener: () => void;
  // Mute hotkey
  onMuteHotkeyChanged: (hotkey: string) => void;
  getMuteHotkey: () => Promise<string>;
  onMuteHotkeyPressed: (callback: () => void) => void;
  removeMuteHotkeyListener: () => void;
  // Skip hotkey
  onSkipHotkeyChanged: (hotkey: string) => void;
  getSkipHotkey: () => Promise<string>;
  onSkipHotkeyPressed: (callback: () => void) => void;
  removeSkipHotkeyListener: () => void;
  // Window controls
  windowMinimize: () => void;
  windowMaximize: () => void;
  windowClose: () => void;
  openExternal: (url: string) => void;
  getDesktopSources: () => Promise<Array<{ id: string; name: string; thumbnail: string }>>;
  isElectron: true;
  platform: string;
}

declare global {
  interface Window {
    electronAPI?: ElectronAPI;
  }
}

export function isElectron(): boolean {
  return typeof window !== 'undefined' && !!window.electronAPI?.isElectron;
}
